import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, ListGroup, Nav, Row,Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import logger from "../../../../../utils/logger";
import {
  addRemedy,
  editRemedy,
  getRemedy,
  getRemedyRequest,
  loadRemedy,
} from "../../../../controller/reducer/remedy";
import TagSelector from "../../common/tag-selector";
import TagDisplay from "../../common/tags";
import LinksInput from "../links";
import "./styles.css";

function RemedyItemEditor() {
  const dispatch = useDispatch();
  const history = useHistory();
  const remedyRequest = useSelector(getRemedyRequest);
  const remedy = useSelector(getRemedy);
  const [title, setTitle] = useState(remedyRequest.title);
  const [reason, setReason] = useState("");
  const [tags, setTags] = useState(
    remedyRequest.tags
      ? remedyRequest.tags.map((t) => ({ value: t, label: t }))
      : []
  );
  const [linkArray, setLinkArray] = useState(
    remedyRequest.links ? remedyRequest.links : []
  );

  const ref = useRef(null);

  logger()(remedyRequest);
  logger()(remedy);

  useEffect(() => {
    if (remedyRequest.type === "edit") {
      dispatch(loadRemedy(remedyRequest.linkedTo));
    }
    if (!remedyRequest._id) {
      history.push("/admin/remedies");
    }
  }, [dispatch, remedyRequest, history]);

  const submit = (result) => {
    const data = {
      id: remedyRequest._id,
      title,
      result,
      tags: tags.map((t) => t.value),
      links: linkArray,
      reason,
      email: remedyRequest.email,
      ref : ref.current===null ? "" : ref.current.innerHTML
    };
    logger()(data); 
    if (remedyRequest.type === "edit") {
      dispatch(editRemedy(data));
    } else {
      dispatch(addRemedy(data));
    }
    history.push("/admin/remedies");
  };
  const submitTask = (e) => {
    e.preventDefault();
    submit("accept");
  };
  const reject = (e) => {
    e.preventDefault();
    submit("reject");
    logger()("reject");
  };

  return (
    <Container fluid>
      <Row>
        <Col sm={7}>
        <Row ref={ref}>
      {remedyRequest.type === "edit" && remedy.links && (
        <Col className="p-4">
          <p className=" h5 font-weight-bold">Old Remedy</p>
          <hr />
          <p className=" h4 font-weight-normal mb-2">Description</p>
          <p className=" h5 font-weight-light mb-4">{remedy.title}</p>
          <p className="h4 font-weight-normal mb-2">Tags</p>
          <TagDisplay tags={remedy.tags} />
          <p className="h4 font-weight-normal mb-2">Links</p>
          <ListGroup className="mb-4">
            {remedy.links.map((link, id) => (
              <ListGroup.Item key={id}>
                <Nav.Link
                  target="_blank"
                  style={{ display: "table-cell" }}
                  href={link}
                >
                  {link}
                </Nav.Link>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Col>
      )}
      <Col className="p-4">
        <p className=" h5 font-weight-bold">New Remedy</p>
        <hr />
        <p className=" h4 font-weight-normal mb-2">Description</p>
        <p className=" h5 font-weight-light mb-4">{title}</p>
        <p className="h4 font-weight-normal mb-2">Tags</p>
        <TagDisplay tags={tags.map((t) => t.value)} />
        <p className="h4 font-weight-normal mb-2">Links</p>
        <ListGroup className="mb-4">
          {linkArray.map((link, id) => (
            <ListGroup.Item key={id}>
              <Nav.Link
                target="_blank"
                style={{ display: "table-cell" }}
                href={link}
              >
                {link}
              </Nav.Link>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Col>
            </Row>
      </Col>

      <Col>
        <Card border="info" className="m-3">
          <Card.Header>
            <Card.Title>Suggest Changes in Resource</Card.Title>
          </Card.Header>
          <Form onSubmit={submitTask}>
            <Card.Body>
              <Form.Group controlId="title">
                <Form.Label>Enter Title*</Form.Label>
                <Form.Control
                  maxLength="500"
                  required
                  as="textarea"
                  rows={2}
                  placeholder="Title"
                  value={title}
                  onChange={(e) => setTitle(e.currentTarget.value)}
                />
                <Form.Text className="text-muted">
                  Make it as descriptive as possible
                </Form.Text>
              </Form.Group>
              <LinksInput />
              <Form.Group controlId="tags">
                <Form.Label>Selected Tags</Form.Label>
                <TagSelector isRemedy={true} tags={tags} setTags={setTags} />
              </Form.Group>
              <Form.Group controlId="links">
                <Form.Label>Entered Links</Form.Label>
                <LinksInput linkArray={linkArray} setLinkArray={setLinkArray} />
              </Form.Group>
              {remedyRequest.type === "edit" && (
                <Form.Group controlId="comment">
                  <Form.Label>Entered Comment</Form.Label>
                  <Form.Control
                    readOnly
                    type="text"
                    placeholder="Comment"
                    value={remedyRequest.comment}
                  />
                  <Form.Text className="text-muted">
                    Justifies the changes made by the user
                  </Form.Text>
                </Form.Group>
              )}
              <Form.Group controlId="email">
                <Form.Label>Entered Email</Form.Label>
                <Form.Control
                  readOnly
                  type="email"
                  placeholder="Email Here"
                  value={remedyRequest.email}
                />
                <Form.Text className="text-muted">
                  Entered email will receive response for your decision
                </Form.Text>
              </Form.Group>
            </Card.Body>
            <Card.Footer>
              <Button block variant="primary" type="submit">
                Accept
              </Button>
            </Card.Footer>
          </Form>
          <Form onSubmit={reject}>
            <Card.Body>
              <Form.Group controlId="reason">
                <Form.Label inline>Entered Reason</Form.Label>
                <Form.Control
                  maxLength="200"
                  type="text"
                  placeholder="Reason"
                  value={reason}
                  onChange={(e) => setReason(e.currentTarget.value)}
                />
                <Form.Text className="text-muted">Make it specific</Form.Text>
              </Form.Group>
            </Card.Body>

            <Card.Footer>
              <Button block variant="danger" type="submit">
                Reject
              </Button>
            </Card.Footer>
          </Form>
        </Card>
      </Col>
      </Row>

    </Container>
  );
}

export default RemedyItemEditor;
